import { render, staticRenderFns } from "./FuelPriceTable.vue?vue&type=template&id=55054f69&"
import script from "./FuelPriceTable.vue?vue&type=script&lang=js&"
export * from "./FuelPriceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/samenaankoop/src/vue-apps/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55054f69')) {
      api.createRecord('55054f69', component.options)
    } else {
      api.reload('55054f69', component.options)
    }
    module.hot.accept("./FuelPriceTable.vue?vue&type=template&id=55054f69&", function () {
      api.rerender('55054f69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "widgets/FuelPriceTable.vue"
export default component.exports